module.exports = {
    init: function () {},
    bindElements: function () {}
};
